import * as cnts from './constants';
import * as cnt from '../../master-template/__storeFiles__/constants';


const initialState = {
  loadingList: true,
  list: [],
};

const updateTemplateProps = (state, id, payload) => {
  return {
    ...state,
    list: state.list.map(obj => {
      if (obj._id === id) {
        return { ...obj, ...payload };
      }
      return obj;
    }),
  };
};

export function masterTemplateList(state = initialState, { type, payload, args, error }) {
  switch (type) {
    case `${cnts.GET_LIST}_SUCCESS`:
      return {
        ...state,
        list: payload,
        loadingList: false,
      };
    case `${cnts.GET_ASSOCIATED_TEMPLATES}_SUCCESS`:
      return {
        ...state,
        list: state.list.map(obj => {
          if (obj._id === args[0].id) {
            return { ...obj, templates: payload };
          }
          return obj;
        }),
      };
    case cnts.UPDATE_TEMPLATE_PROPS:
      return updateTemplateProps(state, payload.id, payload);
    case `${cnts.RENAME_TEMPLATE}_STARTED`:
    case `${cnts.DELETE_TEMPLATE}_STARTED`:
      return updateTemplateProps(state, args[0].id, { callingApi: true });
    case `${cnts.RENAME_TEMPLATE}_SUCCESS`:
      return updateTemplateProps(state, args[0].id, {
        callingApi: false,
        showDeleteConfirmButton: false,
        errorText: '',
        showEditNameConfirmButton: false,
        newTemplateName: '',
        templateName: args[0].newName,
      });
    case `${cnts.DELETE_TEMPLATE}_SUCCESS`:
      return {
        ...state,
        list: state.list.filter(obj => obj._id !== args[0].id),
      };
    case `${cnts.RENAME_TEMPLATE}_ERROR`:
      return updateTemplateProps(state, args[0].id, {
        errorText: error && error.duplicateExists
          ? `There is already a template named "${args[0].newName}".`
          : 'Oops, something went wrong, please try again.',
      });
    default:
      return state;
  }
}

export function createNew(state = { templateName: '' }, { type, payload, args, error }) {
  switch (type) {
    case cnts.INIT:
      return {
        ...state,
        ...payload,
      };
    case cnts.TYPE_NAME:
      return {
        ...state,
        templateName: payload,
      };
    case `${cnts.CREATE}_STARTED`:
      return {
        ...state,
        creating: true,
      };
    case `${cnts.CREATE}_SUCCESS`:
      return {
        ...state,
        creating: false,
      };
    case `${cnts.CREATE}_ERROR`:
      return {
        ...state,
        creating: false,
        error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template-list/__storeFiles__/reducer.js